export const translations = {
  'Too many hints. The next game will not be available.': 'Æгæр берæ хатти агъаз райстай. Нæуæг гъазт нæ райдадзæнæ.',
  'FIXME:Too many hints. Starting the same game in {seconds} seconds.': 'Too many hints. Starting the same game in {seconds} seconds.',
  'FIXME:Good, but letters selection mode is required to pass. Starting the same game in {seconds} seconds.': 'FIXME:Good, but letters selection mode is required to pass. Starting the same game in {seconds} seconds.',
  Autoplay: 'Autoplay',
  'FIXME:At least one word not solved. The next game will not be available.': '',
  'Autoplay site sounds': 'Autoplay site sounds',
  'Start new game in explore mode.': 'Нæуæг æсгарун гъазт райдайун.',
  'Image selection': 'Сорæт æвзарун',
  'Letters selection': 'Дамугътæ æвзарун',
  'Tell again': 'Tell again',
  'Report an issue': 'Report an issue',
  Contribute: 'Contribute',
  'Amazing. The next game will start in {seconds} seconds.': 'Хъæбæр хуарз. Нæуæг гъазт райдайдзæнæй {seconds} секунди фæстæ.',
  'Game skipped. Starting the next game in {seconds} seconds.': 'Гъазт фæццох кодтай. Нæуæг гъазт райдайдзæнæй {seconds} секунди фæстæ.',
  'Amazing. New game will start in {seconds} seconds.': 'Хъæбæр хуарз. Нæуæг гъазт райдайдзæнæй {seconds} секунди фæстæ.',
  Skip: 'Фæццох кæнун',
  'Warning: this is alpha version of the app. Please be ready to lose your progress in explore mode once. Sorry for inconvenience.': 'Кит: алфа верси. Уотæ гæнæн ес æма дæ прогресс байсафдзæнæй еу бон. Ниххатир мин æй кæнæ.',
  Help: 'Агъаз',
  Leave: 'Рандæ ун',
  Contest: 'Ерис',
  'Find rival': 'FIXME:',
  'Start train': 'Ахур райдайун',
  Train: 'Ахур',
  Amazing: 'Хъæбæр хуарз',
  'Amazing. New round will start in {seconds} seconds.': 'Хъæбæр хуарз. Нæуæг раунд райдайдзæнæй {seconds} секунди фæстæ.',
  'Well, but not enough. Try again in {seconds} seconds.': 'Бæззуй, фал фагæ нæ ей. Еу хат ма бафæлварæ {seconds} секунди фæстæ.',
  'Very well. New round will start in {seconds} seconds.': 'Xуарз æй. Нæуæг раунд райдайдзæнæй {seconds} секунди фæстæ.',
  'Very well': 'Хуарз',
  'Well done.': 'Бæззуй.',
  'So bad. You can do better!': 'Лæгъуз. Дæ бон хуæздæр æй!',
  Explore: 'Æсгарун',
  'What?': 'Куд?',
  'You won!': 'Рамболдтай!',
  'Solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Исихалæ {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} æма райдайдзæнæ {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.',
  'Hints limit exceeded. Try to solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} again to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Агъазти лимит фæцæй. Исихалæ {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} again to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.',

  // levels
  Simple: 'Еувазæг',
  Normal: 'Уаггин',
  Hard: 'Гъесгун'
}
